// extracted by mini-css-extract-plugin
module.exports = {"sliderCameres":"slidercameres_sliderCameres__96n6K"};